import { render, staticRenderFns } from "./CompetitionDetailEntryLayout.vue?vue&type=template&id=1fd224fe&scoped=true"
import script from "./CompetitionDetailEntryLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailEntryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd224fe",
  null
  
)

export default component.exports